// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"bz_a bhs_h bhs_ka bhs_ux bhs_ro bhs_un bhs_rq bhs_rh"};